import React from "react";
import PropTypes from "prop-types";

import { UIButton } from "../../../../../../../components/ui";

const ReviewProfileActions = ({
  onReject,
  onApprove,
  rejectLabel,
  approveLabel,
  disabled,
}) => (
  <div className="d-flex flex-wrap justify-content-end gap-2 review-profile-actions">
    <UIButton
      type="button"
      variant="outline"
      size="medium"
      onClick={onReject}
      disabled={disabled}
    >
      {rejectLabel}
    </UIButton>
    <UIButton
      type="button"
      variant="success"
      appearance="outline"
      size="medium"
      onClick={onApprove}
      disabled={disabled}
    >
      {approveLabel}
    </UIButton>
  </div>
);

ReviewProfileActions.propTypes = {
  onReject: PropTypes.func.isRequired,
  onApprove: PropTypes.func.isRequired,
  rejectLabel: PropTypes.string.isRequired,
  approveLabel: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

ReviewProfileActions.defaultProps = {
  disabled: false,
};

export default ReviewProfileActions;
